const RESERVED_STOCK_PRIORITY = 1000000;
const RESERVER_STOCK_MAX_AMOUNT = 3;

export { RESERVED_STOCK_PRIORITY, RESERVER_STOCK_MAX_AMOUNT };
